import React from 'react';
import {
  defineMessages, useIntl, FormattedMessage,
} from 'react-intl';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { FormikCalendar } from '../../../components/prime-formik';
import { validationMessages } from '../../../utils/FormUtils';

const messages = defineMessages({
  infoMessage: {
    id: 'superlink.assessments.update.infoMessage',
    // eslint-disable-next-line max-len
    defaultMessage: 'All assessments with status NEW, INVITED, STARTED will have their expiration date updated with the one provided below.',
  },
});

const SuperLinkAssessmentsExpirationUpdateForm = ({ onSubmit, handleCancel }) => {
  const { formatMessage } = useIntl();

  const infoMessage = formatMessage(messages.infoMessage);

  const initialValues = {
    expirationTime: '',
  };

  const validationSchema = Yup.object().shape({
    expirationTime: Yup.string().required(formatMessage(validationMessages.required)),
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, formikBag) => {
        const { resetForm } = formikBag;
        onSubmit(values);
        resetForm();
      }}
      render={({
        handleSubmit, isSubmitting,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Panel header={infoMessage}>
            <div className="p-grid p-fluid">
              <div className="p-md-6">
                <div className="p-grid">
                  <div className="p-col-12">
                    <Message severity="info" text={infoMessage} />
                  </div>
                  <div className="p-col-12">
                    <label className="field-label" htmlFor="expirationTime">
                      <FormattedMessage id="assessment.timeLimit" defaultMessage="Time Limit" />
                      {' '}
                      <small>
                        <FormattedMessage id="assessment.duration" defaultMessage="(maximum 90 days)" />
                      </small>
                    </label>

                    <Field
                      name="expirationTime"
                      id="expirationTime"
                      component={FormikCalendar}
                      dateFormat="yy-M-dd"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="p-grid">
              <div className="p-col">
                <div className="col-md-6">
                  <FormattedMessage id="actions.save" defaultMessage="Save">
                    {text => (
                      <Button
                        icon={isSubmitting ? 'pi pi-check' : ''}
                        type="submit"
                        label={text}
                        disabled={isSubmitting}
                      />
                    )}
                  </FormattedMessage>
              &nbsp;
                  <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
                    {text => (
                      <Button
                        onClick={handleCancel}
                        className="p-button-secondary"
                        type="button"
                        label={text}
                        disabled={isSubmitting}
                      />
                    )}
                  </FormattedMessage>
                </div>
              </div>
            </div>
          </Panel>
        </Form>
      )}
    />
  );
};

SuperLinkAssessmentsExpirationUpdateForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
};

export default SuperLinkAssessmentsExpirationUpdateForm;
